module.exports = __webpack_public_path__ + "static/media/space.1ed928b7.jpg";